import { ListSubheader, styled } from "@mui/material";

export const SelectListHeader = styled(ListSubheader)`
  background: rgba(0, 0, 0, 0.05);
  font-weight: bold;
  line-height: 36px;
`;
